/*
 * 邮箱脱敏
 * 规则：长度 >= 6 → 显示前3位 + 显示最后1位
 * 规则：长度 < 6 → 显示前1位 + 显示最后1位
 * 规则：长度 = 2 → 显示前1位 + *
 * 边界情况：只有 1 个字符 → 显示 *@邮箱名
 * @param email 邮箱
 * @returns 脱敏后的邮箱
 */
export default function maskEmail(email: string) {
  const [name, domain] = email.split('@');
  const len = name.length;
  // 非法邮箱，没找到 @，直接原样返回
  if (!domain) return email;

  // 规则 1：长度 >= 6 → 前3位 + 最后1位
  if (len >= 6) {
    return (
      name.slice(0, 3) + '*'.repeat(len - 4) + name.slice(-1) + '@' + domain
    );
  }

  // 规则 2：3 =< 长度 < 6 → 前1位 + 最后1位
  if (len >= 3) {
    return (
      name.slice(0, 1) + '*'.repeat(len - 2) + name.slice(-1) + '@' + domain
    );
  }

  // 规则 3：长度 = 2 → 前1位 + *
  if (len === 2) {
    return `${name[0]}*@${domain}`;
  }

  // 边界情况：只有 1 个字符
  return '*@' + domain;
}
